module.exports = __webpack_public_path__ + "static/media/baby-steps-logo.12676342.png";